import "@/assets/styles/mdi.css"; // Local Material Design Icons
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  iconfont: "mdi"
});

const opts = {};

export default new Vuetify(opts);
